<template>
  <el-row type="flex" align="middle" class="nav-header">
    <el-col :span="8" class="flex items-center">
      <router-link to="/" class="flex items-center">
        <img class="nav-logo" src="@/assets/layout/nav_logo.png" alt="logo" />
        <span class="title">{{ projectName }}</span>
      </router-link>
    </el-col>
    <el-col :span="16">
      <ul class="flex items-center justify-end">
        <li>
          <el-dropdown @command="handleCommand">
            <span class="flex items-center">
              <img class="nav-avatar mr-5" src="@/assets/layout/nav_avatar.png" alt="avatar" />
              {{ employeeName }}
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="keyboardShortcuts">快捷键</el-dropdown-item>
              <el-dropdown-item command="clearLocalCache">清除缓存</el-dropdown-item>
              <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </el-col>
    <template v-if="visible">
      <ResetPassword :visible.sync="visible" />
    </template>
  </el-row>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { ChangePwdStorage } from '@/utils/storage'
  import { projectName } from '@/config'
  import { GlobalEventType } from '@/constants'
  export default {
    name: 'Header',
    computed: {
      ...mapGetters({
        employeeName: 'user/employeeName',
      }),
    },
    components: {
      ResetPassword: () => import('@/components/reset-password'),
    },
    data() {
      return {
        projectName,
        visible: false,
      }
    },
    mounted() {
      if (ChangePwdStorage.get()) {
        setTimeout(() => {
          this.visible = process.env.NODE_ENV !== 'development'
        }, 500)
      }
    },
    methods: {
      ...mapActions({
        logout: 'user/logout',
      }),
      handleCommand(command) {
        switch (command) {
          case 'logout':
            this.$mgAlert(`您确定要退出${projectName}吗?`, '温馨提示', { type: 'warning' })
              .then(() => {
                return this.logout()
              })
              .then(() => {
                this.$router.push({ name: 'login' })
              })
            break
          case 'changePassword':
            this.visible = true
            break
          case 'keyboardShortcuts':
            this.$root.$emit(GlobalEventType.KEYBOARD_SHORTCUTS)
            break
          case 'clearLocalCache':
            this.$mgConfirm('确定清除本地缓存?', '提示').then(() => {
              LocalForage.clear()
            })
            break
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .nav-header {
    height: 100%;
    .nav-logo {
      height: 20px;
      margin-right: 10px;
    }
    .nav-avatar {
      width: 20px;
    }
    .title {
      font-size: 15px;
    }
    ul li {
      margin-left: 10px;
    }
  }
</style>
